"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAmount = exports.validateDigitOnly = exports.validateMobileNumber = exports.fixNextPageUrl = void 0;
function fixNextPageUrl(url) {
    const regex = /^http:\/\//;
    if (url != null && regex.test(url)) {
        return url.replace(regex, 'https://');
    }
    return url;
}
exports.fixNextPageUrl = fixNextPageUrl;
const validateMobileNumber = (mobileNumber) => {
    const regex = /^\d{10}$/;
    return regex.test(mobileNumber);
};
exports.validateMobileNumber = validateMobileNumber;
const validateDigitOnly = (value) => {
    const digitRegex = /^\d*$/;
    return digitRegex.test(value);
};
exports.validateDigitOnly = validateDigitOnly;
const formatAmount = (amount, fractionDigit = 2) => {
    const inrFormatter = new Intl.NumberFormat('en-In', {
        maximumFractionDigits: fractionDigit,
    });
    return inrFormatter.format(Number(amount)).replaceAll(',', '');
};
exports.formatAmount = formatAmount;
